import * as React from 'react';
import { Error, ErrorCode } from '~/Api/User/ProductGroup/CzReimbursement';

export const EmptyResultReason: React.FunctionComponent<React.PropsWithChildren<{ error: Error }>> = ({ error }) => {
	switch (error.code) {
		case ErrorCode.OnlyOneProductPerCountryErrorCode:
			return <>Calculation requires at most one product for each country</>;
		case ErrorCode.RequiredProductSettingsMissingErrorCode:
			return <>Required product settings is missing</>;
		case ErrorCode.RequiresReferenceSettingsErrorCode:
			return <>Required reference settings is missing</>;
		case ErrorCode.RequiresAtLeastOneReferenceCountryProduct:
			return <>Calculation requires at least one reference country product</>;
		case ErrorCode.RequiresAtLeastOneProduct:
			return <>Calculation requires at least one product</>;
		case ErrorCode.RequiresAtLeastOneProductList:
			return <>Calculation requires at least one product list</>;
		default:
			return null;
	}
};
